import { createAction } from '@'
import axios from 'axios'
import { getAuth, loginErrorHandle } from '../../@misc'

const ENDPOINT = process.env.REACT_APP_API_URL

export default createAction('EditUser', async params => {
    const auth = getAuth()

    try {
        await axios({
            url: `${ENDPOINT}/users/${params.id}`,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...auth },
            data: {
                password: params.password ? params.password : undefined,
                name: params.name,
                role_id: params.role,
                external: params.external
            }
        })
    } catch (e) {
        loginErrorHandle(e)
        console.error(e)
    }

    if (params.onSuccess) {
        await params.onSuccess()
    }
})
